import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-danger',
  templateUrl: './icon-danger.component.html',
  styleUrls: ['./icon-danger.component.scss']
})
export class IconDangerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
